const section = document.querySelector('.location-section-three');
if (section) {
    const tabs = Array.from(section.querySelectorAll('.location-section-three__tab'));
    const panels = Array.from(section.querySelectorAll('.location-section-three__panel'));
    const panelsContainer = section.querySelector('.location-section-three__panels');

    function getHeight(panel) {
        panel.classList.add('is-active');
        const h = panel.scrollHeight;
        panel.classList.remove('is-active');
        return h;
    }

    function activate(index) {
        const current = panels.findIndex(p => p.classList.contains('is-active'));
        if (current === index) return;

        tabs.forEach((t, i) => t.classList.toggle('is-active', i === index));

        // lock current height before switching
        panelsContainer.style.height = panelsContainer.offsetHeight + 'px';

        panels[current].classList.remove('is-active');
        panels[index].classList.add('is-active');

        // animate to new height
        requestAnimationFrame(() => {
            panelsContainer.style.height = panels[index].scrollHeight + 'px';
        });

        panelsContainer.addEventListener('transitionend', function onEnd() {
            panelsContainer.removeEventListener('transitionend', onEnd);
            panelsContainer.style.height = 'auto';
        }, { once: true });
    }

    tabs.forEach((tab, i) => tab.addEventListener('click', () => activate(i)));

    // tabs mask
    const tabsEl = section.querySelector('.location-section-three__tabs');
    function updateMask() {
        const atStart = tabsEl.scrollLeft <= 1;
        const atEnd = tabsEl.scrollLeft >= tabsEl.scrollWidth - tabsEl.clientWidth - 1;
        tabsEl.classList.toggle('is-start', atStart);
        tabsEl.classList.toggle('is-end', atEnd);
    }
    tabsEl.addEventListener('scroll', updateMask, { passive: true });
    updateMask();

    // init without animation
    panelsContainer.style.transition = 'none';
    panels[0].classList.add('is-active');
    panelsContainer.style.height = 'auto';
    tabs[0].classList.add('is-active');
    requestAnimationFrame(() => { panelsContainer.style.transition = ''; });
}
